export default {
      id: "google-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#google-usage",
      toString: function () {
        return this.url;
      }
    }